import React from 'react';
import Modal from './Modal';
import useModal from './useModal';
import AsButton from '../AsButton';

const MessageModal = ({ id }) => {
    const { modalOptions, removeMessage } = useModal();

    const onClose = () => {
        removeMessage();
    };

    const showButtons = () => {
        return modalOptions.buttons?.map((button, i) => (
            <AsButton
                key={i}
                {...{ ...button, text: undefined, callback: undefined }}
                id={`${id}-button-${button.text.replace(' ', '-')}`}
                style={{ marginLeft: 19, ...button.style }}
                handleClick={() => {
                    onClose();
                    if (button.callback) {
                        button.callback();
                    }
                }}
            >
                {button.text}
            </AsButton>
        ));
    };

    if (!modalOptions) {
        return null;
    }

    return (
        <Modal
            id={id}
            isShowing={!!modalOptions}
            data-testid='message-modal'
            hide={onClose}
            style={modalOptions ? modalOptions.modalStyle : null}
        >
            <div style={{ marginBottom: 58 }}>
                {modalOptions &&
                    modalOptions.message &&
                    (typeof modalOptions.message === 'string' ? (
                        <p id={`${id}-message`}>{modalOptions.message}</p>
                    ) : (
                        modalOptions.message
                    ))}
            </div>
            <div>{showButtons()}</div>
        </Modal>
    );
};

export default MessageModal;
